export default "<form [formGroup]=\"sdwFormGroup\" #formRef>\n  <ng-content></ng-content>\n</form>\n";